import React, { useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { LanguageProvider } from './context/LanguageContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import EventsPage from './pages/EventsPage';
import EventDetailPage from './pages/EventDetailPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ProfilePage from './pages/ProfilePage';
import AdminDashboard from './pages/admin/AdminDashboard';
import EventForm from './pages/admin/EventForm';
import PastEventsPage from './pages/PastEventsPage';
import CategoriesList from './pages/admin/CategoriesList';
import CategoryForm from './pages/admin/CategoryForm';
import CitiesList from './pages/admin/CitiesList';
import CityForm from './pages/admin/CityForm';
import MakeAdminPage from './pages/admin/MakeAdminPage';
import AdminRoute from './components/AdminRoute';

function AppContent() {
  const searchRef = useRef<HTMLInputElement>(null);

  const handleSearchClick = () => {
    if (searchRef.current) {
      searchRef.current.focus();
      searchRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-background">
      <Navbar onSearchClick={handleSearchClick} />
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<HomePage searchRef={searchRef} />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/past-events" element={<PastEventsPage />} />
          <Route path="/events/:id" element={<EventDetailPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/profile" element={<ProfilePage />} />

          {/* Admin Routes */}
          <Route element={<AdminRoute />}>
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/events/new" element={<EventForm />} />
            <Route path="/admin/events/edit/:id" element={<EventForm />} />
            <Route path="/admin/categories" element={<CategoriesList />} />
            <Route path="/admin/categories/new" element={<CategoryForm />} />
            <Route path="/admin/categories/edit/:id" element={<CategoryForm />} />
            <Route path="/admin/cities" element={<CitiesList />} />
            <Route path="/admin/cities/new" element={<CityForm />} />
            <Route path="/admin/cities/edit/:id" element={<CityForm />} />
            <Route path="/admin/make-admin" element={<MakeAdminPage />} />
          </Route>

          {/* Catch all route - redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <Router>
          <AppContent />
        </Router>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;